import { LoadedEntities, StepType } from 'kb-shared/booking/types/types';
import { getAppointmentType } from 'kb-shared/booking/utils/getters';
import { AppointmentType } from 'kb-shared/types';

import { networkClinicCopy } from './networkClinicBookingCopy';

const getLocationStepTitle = ({
  appointment,
  partnerClinicSearch
}: {
  appointment: AppointmentType | null;
  partnerClinicSearch: string | null;
}) => {
  if (partnerClinicSearch === 'search') {
    return networkClinicCopy.findClinic;
  } else if (appointment?.virtual) {
    return '';
  } else {
    return 'Great! Where would you like to meet us?';
  }
};

export const getPageTitle = ({
  stepType,
  selectedProduct,
  partnerClinicSearch
}: {
  stepType: StepType;
  selectedProduct: LoadedEntities['selectedProduct'] | null;
  partnerClinicSearch: string | null;
}) => {
  const appointment = (selectedProduct && getAppointmentType(selectedProduct)) || null;

  switch (stepType) {
    case 'location':
      return getLocationStepTitle({ appointment, partnerClinicSearch });
    case 'time':
      return '';
    case 'consents':
      return 'Consents';
    case 'partner':
      return 'Partner Details';
    case 'insurance':
      return 'Insurance Details';
    case 'confirm':
      return '';
    case 'success':
      return "You're all set!";
    default:
      return '';
  }
};
